export default "__VITE_ASSET__eFK4vIOw__"